const doc = [({"da":({"js":({"admin":({"supplier_supported_sheets":({"create_card":({"create_supplier_supported_sheet":"Opret understøttet ark for leverandør"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;